(() => {
  const GALLERY_CONTROL_SELECTOR = 'slideshow-arrows .slideshow-control';

  document.addEventListener(
    'pointerup',
    (event) => {
      if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

      const control = event.target.closest(GALLERY_CONTROL_SELECTOR);
      if (!(control instanceof HTMLElement)) return;

      window.requestAnimationFrame(() => {
        if (document.activeElement === control) control.blur();
      });
    },
    true
  );
})();
